<div class="rounded-lg justify-end flex flex-col gap-2 relative overflow-hidden cursor-pointer"
  [ngClass]="compact ? 'p-3 aspect-[4/3]' : 'p-4 min-h-36'"
  [style.background-color]="'#317756' | HexToHsl" (click)="onArticleClicked(article.id)">
  <div class="absolute inset-0 w-full h-full bg-primary bg-opacity-60 z-10"></div>
  @if (article.image) {
    <vw-icon-svg [iconUrl]="article.image.src" additionalClasses="absolute inset-0 z-0 w-full h-full object-cover"></vw-icon-svg>
  }
  <div class="relative z-20 flex flex-col gap-1">
    <h3 class="font-semibold text-white"
      [ngClass]="compact ? 'text-sm leading-snug line-clamp-3' : 'text-lg'">
      {{article.title}}
    </h3>
    @if (article.tags.length > 0) {
      <div class="flex flex-col text-white truncate" [ngClass]="compact ? 'text-[11px]' : 'text-sm'">{{article.tags.join(', ')}}</div>
    }
  </div>
</div>